import { get } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import CallSkeleton from '../CallSkeleton';

export interface ICallListSkeleton {
  className?: string;
  itemSize?: number;
}

const CallListSkeleton = ({ itemSize = 135, ...props }: ICallListSkeleton) => {
  const [itemCount, setItemCount] = useState<number>(0);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const wrapperSize = get(wrapperRef.current, 'clientHeight') || 0;
    const newItemCount = Math.ceil(wrapperSize / itemSize);
    setItemCount(newItemCount);
  }, []);

  return (
    <StyledCallSkeleton ref={wrapperRef} {...props}>
      {[...Array(itemCount)].map(() => (
        <CallSkeleton height={itemSize} />
      ))}
    </StyledCallSkeleton>
  );
};

const StyledCallSkeleton = styled.div`
  height: 100%;
`;

export default CallListSkeleton;
